module.exports = __webpack_public_path__ + "media/birds.e8dce67e.mp4";